// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"C_sQ h_jp h_fp h_fs h_fD h_dL h_h","menuItemSub":"C_sR h_dS h_fp h_fD","menuMainLink":"C_sS h_jq h_hk","menuLink":"C_sT h_jq h_hk","Link":"C_rt t_rt t_qS t_rb"};